export default "/img/v12-0-0_fig1.eec2e1417e2b8f8034daf13fe01e9988.png";